import { apiRequest } from './api'

// Brands API service
export const brandsService = {
  // Get all brands
  getAll: async (params = {}) => {
    const queryParams = {}

    // Convert page/page_size to skip/limit
    if (params.page && params.page_size) {
      queryParams.skip = (params.page - 1) * params.page_size
      queryParams.limit = params.page_size
    } else if (params.page_size) {
      queryParams.limit = params.page_size
    }

    if (params.search) queryParams.search = params.search
    if (params.status) {
      // Convert frontend status filter to backend format
      queryParams.is_active = params.status === 'active' ? 'true' : params.status === 'inactive' ? 'false' : undefined
    }

    const response = await apiRequest.get('/brands/', { params: queryParams })
    return response.data
  },

  // Get brand by ID
  getById: async (id) => {
    const response = await apiRequest.get(`/brands/${id}`)
    return response.data
  },

  // Create new brand
  create: async (brandData) => {
    const response = await apiRequest.post('/brands/', brandData)
    return response.data
  },

  // Update brand
  update: async (id, brandData) => {
    const response = await apiRequest.put(`/brands/${id}`, brandData)
    return response.data
  },

  // Delete brand (soft delete)
  delete: async (id) => {
    const response = await apiRequest.delete(`/brands/${id}`)
    return response.data
  },

  // Get brand statistics
  getStats: async (id) => {
    const response = await apiRequest.get(`/brands/${id}/stats`)
    return response.data
  },

  // Get brands for dropdown/select
  getForSelect: async () => {
    const response = await apiRequest.get('/brands/', {
      params: {
        limit: 1000,
        is_active: 'true'
      }
    })
    // Extract brands from paginated response
    const brands = response.data.brands || response.data || []
    return brands.map(brand => ({
      value: brand.id,
      label: brand.name,
      ...brand
    }))
  },
}
